import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  BULK_PURCHASE_CREATE,
  GOODS_CR_DB_NOTES,
  GOODS_ITEMS_GET,
  GOODS_PRINT_DETAILS_GET,
  PURCHASE_INVOICE_PRINT_DETAILS_GET,
  PRINT_LABEL_SETTINGS_SAVE,
  PRINT_LABEL_SETTINGS_GET,
  GOODS_RECEIPT_CREATE,
  GOODS_RECEIPT_CREATE_BULK,
  GOODS_RECEIPT_EDIT,
  GOODS_RECEIPT_VIEW,
  GOODS_RECEIPT_VOID,
  GOODS_TABLE,
  GOODS_TEMP_PRODUCTS_VERIFY,
  GOODS_TEM_PRODUCTS_IMPORT,
  GOODS_USER_TEMPLATE,
  LOAD_MIN_QTY_ITEMS,
  PAYMENT_OUT_CREATE,
  PAYMENT_OUT_EDIT,
  PAYMENT_OUT_TABLE,
  PAYMENT_OUT_VIEW,
  PURCHASE_CREATE,
  PURCHASE_CREDIT_EDIT,
  PURCHASE_CREDIT_RECEIPT_CREATE,
  PURCHASE_CREDIT_TABLE,
  PURCHASE_CREDIT_VIEW,
  PURCHASE_CREDIT_VOID,
  PURCHASE_EDIT,
  PURCHASE_INVOICE_EDIT,
  PURCHASE_INVOICE_ITEMS_GET,
  PURCHASE_INVOICE_RECEIPT_CREATE,
  PURCHASE_INVOICE_TABLE,
  PURCHASE_INVOICE_VIEW,
  PURCHASE_INVOICE_VOID,
  PURCHASE_ITEMS_GET,
  PURCHASE_ITEM_QTY_CONVERSION,
  PURCHASE_PAYMENT_OUT_CUS,
  PURCHASE_PRODUCT_DETAILS,
  PURCHASE_PRODUCT_LIST,
  PURCHASE_RETURN_EDIT,
  PURCHASE_RETURN_ITEMS_GET,
  PURCHASE_RETURN_RECEIPT_CREATE,
  PURCHASE_RETURN_TABLE,
  PURCHASE_RETURN_VIEW,
  PURCHASE_RETURN_VOID,
  PURCHASE_TABLE,
  PURCHASE_TAX_CAL,
  PURCHASE_VIEW,
  PURCHASE_VOID,
  STOCK_OUT_GRN_ITEMS,
  STOCK_OUT_PURCHASE_INVOICE_ITEMS,
  UPLOAD_PO_CSV,
  ITEM_CATEGORY_BULK_PO_LIST,
  ITEM_CATEGORY_BULK_PO_UPDATE,
  ITEM_SALES_SEARCH_BULK_PO,
  ITEM_BULK_PO_UPDATE,
  ITEM_SALES_MOLECULE_BULK_PO,
  PURCHASE_EXPIRY_BIN,
  PURCHASE_SLOW_NON_MOVING_ITEMS,
  PURCHASE_EXPIRED_ITEMS_GET,
  PURCHASE_VENDORS_FOR_ITEM_BATCH_GET,
  PURCHASE_RETURN_BULK_DRAFT_CREATE,
  CREATE_DROPLIST,
  VIEW_DROPLIST,
  UPDATE_DROPLIST,
  DROPLIST_TABLE,
  DROPLIST_DASHBOARD,
  DROPLIST_ITEMS_GET,
  DROPLIST_VIEW_ITEMS,
  VOID_DROPLIST,
} from "../types";

import {
  bulkPurchaseCreateApi,
  goodsCrDBNotesApi,
  goodsEditApi,
  goodsItemsGetApi,
  goodsPrintDetailsApi,
  purchaseInvoicePrintDetailsApi,
  savePrintLabelSettingsApi,
  getPrintLabelSettingsApi,
  goodsReceiptCreateApi,
  goodsReceiptCreateBulkApi,
  goodsTableApi,
  goodsTempProImpApi,
  goodsTempProVeriApi,
  goodsUserTemplateApi,
  goodsViewApi,
  goodsVoidApi,
  loadMinQtyItemsApi,
  paymentOutCreateApi,
  paymentOutEditApi,
  paymentOutTableApi,
  paymentOutViewApi,
  purchaseCreateApi,
  purchaseCreditEditApi,
  purchaseCreditReceiptCreateApi,
  purchaseCreditTableApi,
  purchaseCreditViewApi,
  purchaseCreditVoidApi,
  purchaseEditApi,
  purchaseInvoiceEditApi,
  purchaseInvoiceItemsGetApi,
  purchaseInvoiceReceiptCreateApi,
  purchaseInvoiceTableApi,
  purchaseInvoiceViewApi,
  purchaseInvoiceVoidApi,
  purchaseItemQtyConversionApi,
  purchaseItemsGetApi,
  purchasePaymentOutCusApi,
  purchaseProductDetailsApi,
  purchaseProductListApi,
  purchaseReturnEditApi,
  purchaseReturnItemsGetApi,
  purchaseReturnReceiptCreateApi,
  purchaseReturnTableApi,
  purchaseReturnViewApi,
  purchaseReturnVoidApi,
  purchaseTableApi,
  purchaseTaxCalApi,
  purchaseViewApi,
  purchaseVoidApi,
  stockOutGrnItemsApi,
  stockOutPurchaseInvoiceItemsApi,
  uploadPoCsvApi,
  itemCategoryBulkPOListApi,
  itemCategoryBulkPOUpdateApi,
  itemsSalesSearchBulkPOApi,
  itemBulkPOUpdateApi,
  itemsSalesByMoleculeBulkPOApi,
  purchaseExpiryBinApi,
  purchaseSlowNonMovingItemsApi,
  purchaseExpiredItemsGetApi,
  purchaseVendorsForItemBatchGetApi,
  purchaseReturnBulkDraftCreateApi,
  createDropListApi,
  updateDropListApi,
  viewDropListApi,
  viewDropListItemsApi,
  voidDropListApi,
  dropListTableApi,
  dropListDashboardApi,
  dropListItemsGetApi,
} from "../apis/purchase-api";

export function* purchaseCreateWorker(action) {
  try {
    const res = yield call(purchaseCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseEditWorker(action) {
  try {
    const res = yield call(purchaseEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseTableWorker(action) {
  try {
    const res = yield call(purchaseTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseProductListWorker(action) {
  try {
    const res = yield call(purchaseProductListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockOutGrnItemsWorker(action) {
  try {
    const res = yield call(stockOutGrnItemsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* stockOutPurchaseInvoiceItemsWorker(action) {
  try {
    const res = yield call(stockOutPurchaseInvoiceItemsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseViewWorker(action) {
  try {
    const res = yield call(purchaseViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseVoidWorker(action) {
  try {
    const res = yield call(purchaseVoidApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseItemsGetWorker(action) {
  try {
    const res = yield call(purchaseItemsGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* goodsReceiptCreateWorker(action) {
  try {
    const res = yield call(goodsReceiptCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsReceiptCreateBulkWorker(action) {
  try {
    const res = yield call(goodsReceiptCreateBulkApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* goodsItemsGetWorker(action) {
  try {
    const res = yield call(goodsItemsGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsTableWorker(action) {
  try {
    const res = yield call(goodsTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* goodsViewWorker(action) {
  try {
    const res = yield call(goodsViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsPrintDetailsWorker(action) {
  try {
    const res = yield call(goodsPrintDetailsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseInvoicePrintDetailsWorker(action) {
  try {
    const res = yield call(purchaseInvoicePrintDetailsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* savePrintLabelSettingsWorker(action) {
  try {
    const res = yield call(savePrintLabelSettingsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* getPrintLabelSettingsWorker(action) {
  try {
    const res = yield call(getPrintLabelSettingsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsEditWorker(action) {
  try {
    const res = yield call(goodsEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsVoidWorker(action) {
  try {
    const res = yield call(goodsVoidApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsTempProVeriWorker(action) {
  try {
    const res = yield call(goodsTempProVeriApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsTempProImpWorker(action) {
  try {
    const res = yield call(goodsTempProImpApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsCrDBNotesWorker(action) {
  try {
    const res = yield call(goodsCrDBNotesApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* goodsUserTemplateWorker(action) {
  try {
    const res = yield call(goodsUserTemplateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

// purchase INVOICE
export function* purchaseInvoiceReceiptCreateWorker(action) {
  try {
    const res = yield call(purchaseInvoiceReceiptCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseInvoiceTableWorker(action) {
  try {
    const res = yield call(purchaseInvoiceTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseInvoiceViewWorker(action) {
  try {
    const res = yield call(purchaseInvoiceViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseInvoiceEditWorker(action) {
  try {
    const res = yield call(purchaseInvoiceEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseInvoiceVoidWorker(action) {
  try {
    const res = yield call(purchaseInvoiceVoidApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseInvoiceItemsGetWorker(action) {
  try {
    const res = yield call(purchaseInvoiceItemsGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
// purchase RETURN
export function* purchaseReturnReceiptCreateWorker(action) {
  try {
    const res = yield call(purchaseReturnReceiptCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseReturnTableWorker(action) {
  try {
    const res = yield call(purchaseReturnTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseReturnViewWorker(action) {
  try {
    const res = yield call(purchaseReturnViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseReturnEditWorker(action) {
  try {
    const res = yield call(purchaseReturnEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseReturnVoidWorker(action) {
  try {
    const res = yield call(purchaseReturnVoidApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseReturnItemsGetWorker(action) {
  try {
    const res = yield call(purchaseReturnItemsGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
// purchase CREDIT
export function* purchaseCreditReceiptCreateWorker(action) {
  try {
    const res = yield call(purchaseCreditReceiptCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseCreditTableWorker(action) {
  try {
    const res = yield call(purchaseCreditTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseCreditViewWorker(action) {
  try {
    const res = yield call(purchaseCreditViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseCreditEditWorker(action) {
  try {
    const res = yield call(purchaseCreditEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseCreditVoidWorker(action) {
  try {
    const res = yield call(purchaseCreditVoidApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchasePaymentOutCusWorker(action) {
  try {
    const res = yield call(purchasePaymentOutCusApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paymentOutTableWorker(action) {
  try {
    const res = yield call(paymentOutTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* PaymentOutCreateWorker(action) {
  try {
    const res = yield call(paymentOutCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* PaymentOutEditWorker(action) {
  try {
    const res = yield call(paymentOutEditApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* paymentOutViewWorker(action) {
  try {
    const res = yield call(paymentOutViewApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* loadMinQtyItemsWorker(action) {
  try {
    const res = yield call(loadMinQtyItemsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* bulkPurchaseCreateWorker(action) {
  try {
    const res = yield call(bulkPurchaseCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* uploadPoCsvWorker(action) {
  try {
    const res = yield call(uploadPoCsvApi, action.data);

    if (res.status === 200 && res?.data?.code === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseTaxCalWorker(action) {
  try {
    const res = yield call(purchaseTaxCalApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseProductDetailsWorker(action) {
  try {
    const res = yield call(purchaseProductDetailsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* purchaseItemQtyConversionWorker(action) {
  try {
    const res = yield call(purchaseItemQtyConversionApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseExpiryBinWorker(action) {
  try {
    const res = yield call(purchaseExpiryBinApi, action.data);
    if (res.status === 200) {
      if(res?.data?.data?.itemData.length==0){
        yield action.onError({"message":'No items to load'});
      }else{
        yield action.onSuccess(res.data);
      }
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* bulkPurchaseCreateWatcher() {
  // takeEvery, not takeLatest: the bulk PO screen dispatches one
  // BULK_PURCHASE_CREATE per document in a sequential create loop — takeLatest
  // would cancel an in-flight document's request the moment the next one is
  // dispatched, and a cancelled saga task never calls onSuccess/onError,
  // leaving the "Adding X out of N" progress modal stuck forever.
  yield takeEvery(BULK_PURCHASE_CREATE, bulkPurchaseCreateWorker);
}
export function* loadMinQtyItemsWatcher() {
  yield takeLatest(LOAD_MIN_QTY_ITEMS, loadMinQtyItemsWorker);
}

export function* paymentOutViewWatcher() {
  yield takeLatest(PAYMENT_OUT_VIEW, paymentOutViewWorker);
}

export function* PaymentOutCreateWatcher() {
  yield takeLatest(PAYMENT_OUT_CREATE, PaymentOutCreateWorker);
}
export function* paymentOutEditWatcher() {
  yield takeLatest(PAYMENT_OUT_EDIT, PaymentOutEditWorker);
}

export function* paymentOutTableWatcher() {
  yield takeLatest(PAYMENT_OUT_TABLE, paymentOutTableWorker);
}
export function* salesPaymentOutCusWatcher() {
  yield takeLatest(PURCHASE_PAYMENT_OUT_CUS, purchasePaymentOutCusWorker);
}
export function* purchaseCreateWatcher() {
  // takeEvery, not takeLatest: the bulk PO screen's per-document create loop
  // now dispatches PURCHASE_CREATE (not BULK_PURCHASE_CREATE) sequentially —
  // takeLatest would cancel an in-flight document's request the moment the
  // next is dispatched, and a cancelled saga task never calls
  // onSuccess/onError, leaving the "Adding X out of N" modal stuck forever.
  // Harmless for the regular single-PO screen, which only ever dispatches
  // this once per submit.
  yield takeEvery(PURCHASE_CREATE, purchaseCreateWorker);
}
export function* purchaseEditWatcher() {
  yield takeLatest(PURCHASE_EDIT, purchaseEditWorker);
}
export function* purchaseTableWatcher() {
  yield takeLatest(PURCHASE_TABLE, purchaseTableWorker);
}
export function* purchaseProductListWatcher() {
  yield takeLatest(PURCHASE_PRODUCT_LIST, purchaseProductListWorker);
}
export function* stockOutGrnItemsWatcher() {
  yield takeLatest(STOCK_OUT_GRN_ITEMS, stockOutGrnItemsWorker);
}
export function* stockOutPurchaseInvoiceItemsWatcher() {
  yield takeLatest(
    STOCK_OUT_PURCHASE_INVOICE_ITEMS,
    stockOutPurchaseInvoiceItemsWorker
  );
}
export function* purchaseViewWatcher() {
  yield takeLatest(PURCHASE_VIEW, purchaseViewWorker);
}
export function* purchaseVoidWatcher() {
  yield takeLatest(PURCHASE_VOID, purchaseVoidWorker);
}
export function* purchaseItemsGetWatcher() {
  yield takeLatest(PURCHASE_ITEMS_GET, purchaseItemsGetWorker);
}

export function* goodsTableWatcher() {
  yield takeLatest(GOODS_TABLE, goodsTableWorker);
}
export function* goodsReceiptCreateWatcher() {
  yield takeLatest(GOODS_RECEIPT_CREATE, goodsReceiptCreateWorker);
}
export function* goodsReceiptCreateBulkWatcher() {
  yield takeLatest(GOODS_RECEIPT_CREATE_BULK, goodsReceiptCreateBulkWorker);
}
export function* goodsItemsGetWatcher() {
  yield takeLatest(GOODS_ITEMS_GET, goodsItemsGetWorker);
}

export function* goodsViewWatcher() {
  yield takeLatest(GOODS_RECEIPT_VIEW, goodsViewWorker);
}
export function* goodsVoidWatcher() {
  yield takeLatest(GOODS_RECEIPT_VOID, goodsVoidWorker);
}
export function* goodsPrintDetailsWatcher() {
  yield takeLatest(GOODS_PRINT_DETAILS_GET, goodsPrintDetailsWorker);
}
export function* purchaseInvoicePrintDetailsWatcher() {
  yield takeLatest(
    PURCHASE_INVOICE_PRINT_DETAILS_GET,
    purchaseInvoicePrintDetailsWorker
  );
}
export function* savePrintLabelSettingsWatcher() {
  yield takeLatest(PRINT_LABEL_SETTINGS_SAVE, savePrintLabelSettingsWorker);
}
export function* getPrintLabelSettingsWatcher() {
  yield takeLatest(PRINT_LABEL_SETTINGS_GET, getPrintLabelSettingsWorker);
}
export function* goodsEditWatcher() {
  yield takeLatest(GOODS_RECEIPT_EDIT, goodsEditWorker);
}
export function* goodsTempProVeriWatcher() {
  yield takeLatest(GOODS_TEMP_PRODUCTS_VERIFY, goodsTempProVeriWorker);
}
export function* goodsTempProImpWatcher() {
  yield takeLatest(GOODS_TEM_PRODUCTS_IMPORT, goodsTempProImpWorker);
}
export function* goodsCrDBNotesWatcher() {
  yield takeLatest(GOODS_CR_DB_NOTES, goodsCrDBNotesWorker);
}
export function* goodsUserTemplateWatcher() {
  yield takeLatest(GOODS_USER_TEMPLATE, goodsUserTemplateWorker);
}

// purchase INVOICE
export function* purchaseInvoiceTableWatcher() {
  yield takeLatest(PURCHASE_INVOICE_TABLE, purchaseInvoiceTableWorker);
}

export function* purchaseInvoiceReceiptCreateWatcher() {
  yield takeLatest(
    PURCHASE_INVOICE_RECEIPT_CREATE,
    purchaseInvoiceReceiptCreateWorker
  );
}

export function* purchaseInvoiceViewWatcher() {
  yield takeLatest(PURCHASE_INVOICE_VIEW, purchaseInvoiceViewWorker);
}
export function* purchaseInvoiceEditWatcher() {
  yield takeLatest(PURCHASE_INVOICE_EDIT, purchaseInvoiceEditWorker);
}
export function* purchaseInvoiceVoidWatcher() {
  yield takeLatest(PURCHASE_INVOICE_VOID, purchaseInvoiceVoidWorker);
}
export function* purchaseInvoiceItemsGetWatcher() {
  yield takeLatest(PURCHASE_INVOICE_ITEMS_GET, purchaseInvoiceItemsGetWorker);
}

// PURCHASE RETURN
export function* purchaseReturnTableWatcher() {
  yield takeLatest(PURCHASE_RETURN_TABLE, purchaseReturnTableWorker);
}

export function* purchaseReturnReceiptCreateWatcher() {
  yield takeLatest(
    PURCHASE_RETURN_RECEIPT_CREATE,
    purchaseReturnReceiptCreateWorker
  );
}

export function* purchaseReturnViewWatcher() {
  yield takeLatest(PURCHASE_RETURN_VIEW, purchaseReturnViewWorker);
}
export function* purchaseReturnEditWatcher() {
  yield takeLatest(PURCHASE_RETURN_EDIT, purchaseReturnEditWorker);
}
export function* purchaseReturnVoidWatcher() {
  yield takeLatest(PURCHASE_RETURN_VOID, purchaseReturnVoidWorker);
}
export function* purchaseReturnItemsGetWatcher() {
  yield takeLatest(PURCHASE_RETURN_ITEMS_GET, purchaseReturnItemsGetWorker);
}
// PURCHASE CREDIT
export function* purchaseCreditTableWatcher() {
  yield takeLatest(PURCHASE_CREDIT_TABLE, purchaseCreditTableWorker);
}

export function* purchaseCreditReceiptCreateWatcher() {
  yield takeLatest(
    PURCHASE_CREDIT_RECEIPT_CREATE,
    purchaseCreditReceiptCreateWorker
  );
}

export function* purchaseCreditViewWatcher() {
  yield takeLatest(PURCHASE_CREDIT_VIEW, purchaseCreditViewWorker);
}
export function* purchaseCreditVoidWatcher() {
  yield takeLatest(PURCHASE_CREDIT_VOID, purchaseCreditVoidWorker);
}
export function* purchaseCreditEditWatcher() {
  yield takeLatest(PURCHASE_CREDIT_EDIT, purchaseCreditEditWorker);
}
export function* uploadPoCsvWatcher() {
  yield takeLatest(UPLOAD_PO_CSV, uploadPoCsvWorker);
}

export function* purchaseTaxCalWatcher() {
  yield takeLatest(PURCHASE_TAX_CAL, purchaseTaxCalWorker);
}

export function* purchaseProductDetailsWatcher() {
  yield takeLatest(PURCHASE_PRODUCT_DETAILS, purchaseProductDetailsWorker);
}
export function* purchaseItemQtyConversionWatcher() {
  yield takeLatest(PURCHASE_ITEM_QTY_CONVERSION, purchaseItemQtyConversionWorker);
}

// ITEM INVENTORY SETUP (BULK PO)
export function* itemCategoryBulkPOListWorker(action) {
  try {
    const res = yield call(itemCategoryBulkPOListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemCategoryBulkPOUpdateWorker(action) {
  try {
    const res = yield call(itemCategoryBulkPOUpdateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemsSalesSearchBulkPOWorker(action) {
  try {
    const res = yield call(itemsSalesSearchBulkPOApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemBulkPOUpdateWorker(action) {
  try {
    const res = yield call(itemBulkPOUpdateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* itemsSalesByMoleculeBulkPOWorker(action) {
  try {
    const res = yield call(itemsSalesByMoleculeBulkPOApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* itemCategoryBulkPOListWatcher() {
  yield takeLatest(ITEM_CATEGORY_BULK_PO_LIST, itemCategoryBulkPOListWorker);
}
export function* itemCategoryBulkPOUpdateWatcher() {
  yield takeLatest(
    ITEM_CATEGORY_BULK_PO_UPDATE,
    itemCategoryBulkPOUpdateWorker
  );
}
export function* itemsSalesSearchBulkPOWatcher() {
  yield takeLatest(ITEM_SALES_SEARCH_BULK_PO, itemsSalesSearchBulkPOWorker);
}
export function* itemBulkPOUpdateWatcher() {
  yield takeLatest(ITEM_BULK_PO_UPDATE, itemBulkPOUpdateWorker);
}
export function* itemsSalesByMoleculeBulkPOWatcher() {
  yield takeLatest(
    ITEM_SALES_MOLECULE_BULK_PO,
    itemsSalesByMoleculeBulkPOWorker
  );
}

export function* purchaseExpiryBinWatcher() {
  yield takeLatest(PURCHASE_EXPIRY_BIN, purchaseExpiryBinWorker);
}
export function* purchaseSlowNonMovingItemsWorker(action) {
  try {
    const res = yield call(purchaseSlowNonMovingItemsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseSlowNonMovingItemsWatcher() {
  yield takeLatest(PURCHASE_SLOW_NON_MOVING_ITEMS, purchaseSlowNonMovingItemsWorker);
}

export function* purchaseExpiredItemsGetWorker(action) {
  try {
    const res = yield call(purchaseExpiredItemsGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseExpiredItemsGetWatcher() {
  yield takeLatest(PURCHASE_EXPIRED_ITEMS_GET, purchaseExpiredItemsGetWorker);
}

export function* purchaseVendorsForItemBatchGetWorker(action) {
  try {
    const res = yield call(purchaseVendorsForItemBatchGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseVendorsForItemBatchGetWatcher() {
  yield takeLatest(PURCHASE_VENDORS_FOR_ITEM_BATCH_GET, purchaseVendorsForItemBatchGetWorker);
}

export function* purchaseReturnBulkDraftCreateWorker(action) {
  try {
    const res = yield call(purchaseReturnBulkDraftCreateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* purchaseReturnBulkDraftCreateWatcher() {
  yield takeLatest(PURCHASE_RETURN_BULK_DRAFT_CREATE, purchaseReturnBulkDraftCreateWorker);
}

//drop list
export function* createDropListWorker(action) {
  try {
    const res = yield call(createDropListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* viewDropListWorker(action) {
  try {
    const res = yield call(viewDropListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* viewDropListItemsWorker(action) {
  try {
    const res = yield call(viewDropListItemsApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* updateDropListWorker(action) {
  try {
    const res = yield call(updateDropListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* voidDropListWorker(action) {
  try {
    const res = yield call(voidDropListApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* dropListTableWorker(action) {
  try {
    const res = yield call(dropListTableApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* dropListDashboardWorker(action) {
  try {
    const res = yield call(dropListDashboardApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}
export function* dropListItemsGetWorker(action) {
  try {
    const res = yield call(dropListItemsGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* createDropListWatcher() {
  yield takeLatest(CREATE_DROPLIST, createDropListWorker);
}
export function* viewDropListWatcher() {
  yield takeLatest(VIEW_DROPLIST, viewDropListWorker);
}
export function* viewDropListItemsWatcher() {
  yield takeLatest(DROPLIST_VIEW_ITEMS, viewDropListItemsWorker);
}
export function* updateDropListWatcher() {
  yield takeLatest(UPDATE_DROPLIST, updateDropListWorker);
}
export function* voidDropListWatcher() {
  yield takeLatest(VOID_DROPLIST, voidDropListWorker);
}
export function* dropListTableWatcher() {
  yield takeLatest(DROPLIST_TABLE, dropListTableWorker);
}
export function* dropListDashboardWatcher() {
  yield takeLatest(DROPLIST_DASHBOARD, dropListDashboardWorker);
}
export function* dropListItemsGetWatcher() {
  yield takeLatest(DROPLIST_ITEMS_GET, dropListItemsGetWorker);
}